import { Parser } from "json2csv";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import formatSubscriber from "../../../utils/format-sub";
import { lastInByMember } from "../door-access/door-visits-utils";
import tryLoad from "../door-access/try-load";
import MembershipList from "./membership-list";

/**
 * Door data for the Last in column and the drawer. Only owners and admins of
 * a gym connected to FaciliKey get it; anything else (or any failure) leaves
 * the list exactly as it was.
 */
const loadDoorAccess = async (load) => {
  const status = await tryLoad(load, "doorAccessStatus");
  if (!status.connected || !status.can?.lastIn) return null;
  const { members } = await tryLoad(load, "doorLastIn");
  if (!members) return null;
  return { timeZone: status.timeZone, lastIn: lastInByMember(members) };
};

/** The drawer's Last visit line, only for a member that has a FaciliKey key. */
const loadDrawerSummary = async (load, doorAccess, subs, customer) => {
  const sub = customer && subs.find((item) => item.customer === customer);
  if (!doorAccess || !sub || sub.isPass || !sub.plan?.metadata?.facilikey) {
    return;
  }
  await tryLoad(load, "doorMemberSummary", { memberId: customer });
};

const MembershipListController = async ({ req, res, load, locals, api }) => {
  const { query } = req;
  let page = -1;
  if (typeof query.page !== "undefined") {
    page = query.page;
  }

  const allSubs = locals.activeUser.organizationId
    ? await load("subscribersListExport", {
        memberships: true,
        organizationUser: locals.activeUserToRequest._id,
      })
    : await load("subscribersListExport", { memberships: true });

  const doorAccess = await loadDoorAccess(load);
  const formattedSubs = allSubs.subscriptions.data.map(formatSubscriber);
  const fields = [
    "customer_name",
    "customer_email",
    "phoneNumber",
    "plan.interval",
    "created",
    { label: "tenure (months)", value: "tenure" },
    "current_period_start",
    "lastPayment",
    "lifetimeRevenue",
    "status",
    "paymentStatus",
  ];

  const json2csvParser = new Parser({ fields, unwind: ["plan"] });
  const csv = json2csvParser.parse(formattedSubs);

  if (query.customer) {
    if (locals.activeUser.organizationId) {
      await load("subscriberInvoices", {
        customer: query.customer,
        productType: "PRESS",
        organizationUser: locals.activeUserToRequest._id,
      });
    } else {
      await load("subscriberInvoices", {
        customer: query.customer,
        productType: "PRESS",
      });
    }
  }

  if (query.customer && query.price) {
    await load("upcomingInvoice", query);
  }

  await loadDrawerSummary(load, doorAccess, formattedSubs, query.customer);

  const modal = query.modal || {};

  locals.modal = {
    "activity-feed": <ActivityDrawer />,
  }[modal.type];
  res.body = (
    <MembershipList
      allSubs={allSubs}
      subscribers={formattedSubs}
      csvString={csv}
      page={page}
      key="members"
      api={api}
      doorAccess={doorAccess}
    />
  );
};

export default MembershipListController;
